import styled from 'vue3-styled-components';

// 모달 오버레이
export const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

// 모달 컨텐츠
export const ModalContent = styled.div`
    background: white;
    border-radius: 16px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    width: 90%;
    max-width: 800px;
    max-height: 85vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    animation: slideInUp 0.3s ease-out;
    
    @keyframes slideInUp {
        from {
            opacity: 0;
            transform: translateY(40px) scale(0.95);
        }
        to {
            opacity: 1;
            transform: translateY(0) scale(1);
        }
    }
`;

// 모달 헤더
export const ModalHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px 32px;
    border-bottom: 1px solid #e5e7eb;
    background: linear-gradient(135deg, #0f4c5c 0%, #1a6b7a 100%);
    color: white;
`;

// 모달 제목
export const ModalTitle = styled.h2`
    margin: 0;
    font-size: 24px;
    font-weight: 700;
    color: white;
`;

// 닫기 버튼
export const CloseButton = styled.button`
    background: none;
    border: none;
    color: white;
    font-size: 28px;
    cursor: pointer;
    padding: 0;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.2s ease;

    &:hover {
        background: rgba(255, 255, 255, 0.2);
        transform: scale(1.1);
    }
`;

// 모달 바디
export const ModalBody = styled.div`
    padding: 32px;
    overflow-y: auto;
    flex: 1;
`;

// 폼 컨테이너
export const FormContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

// 폼 행
export const FormRow = styled.div`
    display: flex;
    gap: 24px;
    align-items: flex-start;

    @media (max-width: 768px) {
        flex-direction: column;
        gap: 16px;
    }
`;

// 폼 그룹
export const FormGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: ${props => props.fullWidth ? '1 1 100%' : '1'};
`;

// 폼 라벨
export const FormLabel = styled.label`
    font-size: 14px;
    font-weight: 600;
    color: #374151;
    margin-bottom: 4px;

    &::after {
        content: ${props => props.required ? ' *' : ''};
        color: #ef4444;
    }
`;

// 폼 입력
export const FormInput = styled.input`
    padding: 12px 16px;
    border: 2px solid #e5e7eb;
    border-radius: 8px;
    font-size: 14px;
    transition: all 0.2s ease;
    background: #ffffff;
    color: #1f2937;

    &:focus {
        outline: none;
        border-color: #0f4c5c;
        box-shadow: 0 0 0 3px rgba(15, 76, 92, 0.1);
    }

    &:readonly {
        background: #f9fafb;
        color: #6b7280;
        cursor: pointer;
    }

    &::placeholder {
        color: #9ca3af;
    }
`;

// 주소 입력 그룹
export const AddressInputGroup = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
`;

// 주소 검색 버튼
export const AddressSearchButton = styled.button`
    padding: 12px 16px;
    background: linear-gradient(135deg, #0f4c5c 0%, #1a6b7a 100%);
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    white-space: nowrap;
    margin-left: 10px;

    &:hover {
        transform: translateY(-1px);
    }

    &:active {
        transform: translateY(0);
    }
`;

// 파일 업로드 버튼
export const FileUploadButton = styled.button`
    padding: 8px 16px;
    background: #10b981;
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background: #059669;
        transform: translateY(-1px);
    }

    &:active {
        transform: translateY(0);
    }
`;

// 파일 정보
export const FileInfo = styled.div`
    font-size: 12px;
    color: #6b7280;
    margin-top: 4px;
    padding: 4px 8px;
    background: #f3f4f6;
    border-radius: 4px;
    word-break: break-all;
`;

// 모달 푸터
export const ModalFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 16px;
    padding: 24px 32px;
    border-top: 1px solid #e5e7eb;
    background: #f9fafb;
`;

// 취소 버튼
export const CancelButton = styled.button`
    padding: 12px 24px;
    background: #f3f4f6;
    color: #374151;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background: #e5e7eb;
        border-color: #9ca3af;
    }
`;

// 저장 버튼
export const SaveButton = styled.button`
    padding: 12px 24px;
    background: linear-gradient(135deg, #0f4c5c 0%, #1a6b7a 100%);
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 4px 15px rgba(15, 76, 92, 0.2);

    &:hover {
        background: linear-gradient(135deg, #1a6b7a 0%, #0f4c5c 100%);
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(15, 76, 92, 0.3);
    }

    &:active {
        transform: translateY(0);
    }
`;